export enum AppRoutesEnum {
  anlagePlanung = 'anlageplanung',
  belvoto = 'belvoto',
  callback='callback',
  cockpit = 'cockpit',
  ninHistory = 'nin-history',
}
